export default function WorkflowProcess() {
  const steps = [
    {
      number: '01',
      title: '需求分析与评估',
      description: '深入了解您的业务流程和文档管理现状，识别痛点和改进机会，制定定制化解决方案。',
      icon: 'ri-search-eye-line'
    },
    {
      number: '02',
      title: '工作流程设计',
      description: '绘制完整的文档工作流程图，明确每个步骤、责任人和决策点，优化流程效率。',
      icon: 'ri-flow-chart'
    },
    {
      number: '03',
      title: '系统选型与集成',
      description: '根据需求选择合适的文档管理系统，确保与现有IT基础设施无缝集成。',
      icon: 'ri-settings-3-line'
    },
    {
      number: '04',
      title: '安全策略实施',
      description: '部署强大的身份验证、权限管理和加密措施，确保文档安全和合规性。',
      icon: 'ri-shield-check-line'
    },
    {
      number: '05',
      title: '培训与推广',
      description: '为员工提供全面培训，确保团队能够熟练使用新系统，实现平稳过渡。',
      icon: 'ri-graduation-cap-line'
    },
    {
      number: '06',
      title: '持续优化支持',
      description: '监控系统运行状态，收集反馈，持续优化工作流程，确保长期成功。',
      icon: 'ri-line-chart-line'
    }
  ];

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            我们的咨询服务流程
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            六步法确保文档工作流程实施的成功，从需求分析到持续优化，全程专业支持
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {steps.map((step, index) => (
            <div 
              key={index}
              className="relative group"
            >
              <div className="bg-gradient-to-br from-gray-50 to-white p-8 rounded-2xl border border-gray-200 hover:border-teal-300 hover:shadow-xl transition-all duration-300 h-full">
                <div className="flex items-start gap-4 mb-4">
                  <div className="text-5xl font-bold text-teal-500/20 group-hover:text-teal-500/40 transition-colors duration-300">
                    {step.number}
                  </div>
                  <div className="w-12 h-12 bg-teal-500 rounded-xl flex items-center justify-center flex-shrink-0 group-hover:scale-110 transition-transform duration-300">
                    <i className={`${step.icon} text-xl text-white`}></i>
                  </div>
                </div>
                
                <h3 className="text-xl font-bold text-gray-900 mb-3">
                  {step.title}
                </h3>
                <p className="text-gray-600 leading-relaxed">
                  {step.description}
                </p>
              </div>
              
              {index < steps.length - 1 && (
                <div className="hidden lg:block absolute top-1/2 -right-4 w-8 h-0.5 bg-gradient-to-r from-teal-300 to-transparent transform -translate-y-1/2 z-10"></div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
